<template>
  <v-navigation-drawer
    app
    v-model="drawer"
    :dark="darkTheme"
    :light="!darkTheme"
    :fixed="true"
    :permanent="!isMobile"
    :temporary="isMobile"
    :touchless="true"
    :stateless="true"
    :mini-variant="mini"
    :mini-variant-width="80"
    :disable-resize-watcher="true"
    :disable-route-watcher="true"
    :style="{
      zIndex: 6,
      backgroundColor: darkTheme ? '#0a1332' : '#f2f4f8',
      color: darkTheme ? '#fff' : '#000'
    }"
    :class="darkTheme ? 'navigation-dark' : 'navigation-light'"
  >
    <div
      class="navigation-container"
      :style="{
        alignItems: mini ? 'center' : 'stretch'
      }"
    >
      <div class="navigation-header">
        <v-toolbar-side-icon v-if="mini" @click.native="changeNavicationMini"></v-toolbar-side-icon>
        <HeaderSidebarV2
          v-else
          @changeNavicationMini="changeNavicationMini"
          @handleSearchMenu="handleOnChange"
        />
      </div>
      <div class="navigation-content">
        <div v-if="profile" style="height: 100%">
          <div v-if="hasKaProfileV2" class="menu-content-v2">
            <SidebarV2
              v-if="!notFound && !mini"
              :mini="mini"
              :resultListV2="navItems"
              :panel="panel"
              @onChangeRoute="onClickToNavicationItem"
            />
            <SidebarV2Collapse
              v-else-if="mini && !notFound"
              :groupedNavItems="groupedNavItems"
              @onChangeRoute="onClickToNavicationItem"
            />
            <SearchNotFound v-else-if="notFound && !mini" :searchContext="searchContext" />
          </div>
          <div v-else class="menu-content-v1">
            <ListMenuV1Collapse
              v-if="mini"
              :mini="mini"
              :navItem="navItems"
              @onChangeRoute="onClickToNavicationItem"
            />
            <SearchNotFound v-else-if="notFound && !mini" :searchContext="searchContext" />

            <ListMenuV1
              v-else
              :mini="mini"
              :navItem="data_feat_v1.length > 0 ? data_feat_v1 : navItems"
              @onChangeRoute="onClickToNavicationItem"
            />
          </div>
        </div>
        <div v-else style="height: 100%">
          <div class="menu-content-v1">
            <ListMenuItemMiniWithoutProfile
              v-if="mini"
              :mini="mini"
              @onChangeRoute="onClickToNavicationItem"
            />

            <ListMenuItemWithoutProfile
              v-else
              :mini="mini"
              @onChangeRoute="onClickToNavicationItem"
            />
          </div>
        </div>
      </div>
      <div class="navigation-footer" v-if="profile && token">
        <div v-if="mini" class="footer-container-mini">
          <div :class="darkTheme ? 'dark-divider-line' : 'divider-line'"></div>
          <div class="info-container-mini">
            <v-list-tile-avatar
              name="avatar"
              color="accent"
              class="white--text avatar-content"
              @click="
                $router.push({ path: '/profile' })
                changeNavicationMini()
              "
            >
              <img :src="profile && profile.avatar" v-img-fallback-text="profile.name" />
            </v-list-tile-avatar>
          </div>
          <div :class="darkTheme ? 'dark-divider-line' : 'divider-line'"></div>

          <div class="logout-content-mini">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-tile-action name="close" @click="logout">
                  <v-icon class="logout-icon" color="#F5222D" v-on="on">logout</v-icon>
                </v-list-tile-action>
              </template>
              <span class="text-tooltip">Đăng xuất</span>
              <span v-show="!mini">Đăng xuất</span>
            </v-tooltip>
          </div>
        </div>

        <div v-else class="footer-container">
          <div :class="darkTheme ? 'dark-divider-line' : 'divider-line'"></div>

          <div class="info-container" @click="$router.push({ path: '/profile' })">
            <v-list-tile-avatar name="avatar" color="accent" class="white--text">
              <img :src="profile && profile.avatar" v-img-fallback-text="profile.name" />
            </v-list-tile-avatar>
            <div class="personal-content">
              <v-list-tile-content
                :title="titleInfo"
                class="ml-0"
                @click="$router.push({ path: '/profile' })"
              >
                <v-list-tile-title
                  name="user_name"
                  v-dompurify-html="(profile && profile.name) || ''"
                ></v-list-tile-title>
                <v-list-tile-sub-title
                  name="phone"
                  v-dompurify-html="(profile && profile.phone) || ''"
                ></v-list-tile-sub-title>
              </v-list-tile-content>
            </div>
          </div>
          <div :class="darkTheme ? 'dark-divider-line' : 'divider-line'"></div>

          <div class="logout-content" @click="logout">
            <v-list-tile-action name="close" style="min-width: auto !important">
              <v-icon color="#F5222D" v-on="on">logout</v-icon>
            </v-list-tile-action>
            <span
              :style="{
                fontSize: '16px',
                fontWeight: 600,
                color: '#F5222D'
              }"
              v-show="!mini"
              >Đăng xuất</span
            >
          </div>
          <div class="version-text">
            <p>Version: HEAD.ff99418-0629.1836</p>
          </div>
        </div>
      </div>
      <div class="navigation-footer" v-else>
        <div v-if="mini" class="footer-container-mini">
          <div :class="darkTheme ? 'dark-divider-line' : 'divider-line'"></div>
          <div class="info-container-mini">
            <v-list-tile-avatar
              name="avatar"
              color="accent"
              class="white--text avatar-content"
              :style="{ width: '24px !important', height: '24px !important' }"
            >
              <img
                :style="{ width: '24px !important', height: '24px !important' }"
                src="/assets/images/default-avatar.png"
              />
            </v-list-tile-avatar>
          </div>
        </div>

        <div v-else class="footer-container">
          <div :class="darkTheme ? 'dark-divider-line' : 'divider-line'"></div>

          <div class="info-container">
            <v-list-tile-avatar
              name="avatar"
              color="accent"
              class="white--text"
              @click="$router.push({ path: '/profile' })"
              :style="{ width: '24px !important', height: '24px !important' }"
            >
              <img
                src="/assets/images/default-avatar.png"
                :style="{ width: '24px !important', height: '24px !important' }"
              />
            </v-list-tile-avatar>
            <div class="personal-content">
              <v-list-tile-content class="ml-0" @click="$router.push({ path: '/profile' })">
                Khách
              </v-list-tile-content>
            </div>
          </div>

          <div class="version-text">
            <p>Version: HEAD.ff99418-0629.1836</p>
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>
<script>
import HeaderSidebarV2 from './HeaderSidebarV2.vue'
import SidebarV2 from './SidebarV2.vue'
import SidebarV2Collapse from './SidebarV2Collapse'
import SearchNotFound from './SearchNotFound.vue'
import ListMenuV1 from './ListMenuV1.vue'
import ListMenuItemWithoutProfile from './ListMenuItemWithoutProfile.vue'
import ListMenuV1Collapse from './ListMenuV1Collapse.vue'
import ListMenuItemMiniWithoutProfile from './ListMenuItemMiniWithoutProfile.vue'
import Fuse from 'fuse.js'
const { get, groupBy, debounce } = require('@/plugins/lodash')
import { removeItemStorage, getItemStorage } from '../../../plugins/util'
import { flatten } from 'lodash'
const TRACKING_EVENTS = {
  'new-order': 'NAVIGATION_DRAWER_NEW_ORDER',
  history: 'NAVIGATION_DRAWER_RECORDS',
  balance: 'NAVIGATION_DRAWER_BALANCE',
  employees: 'NAVIGATION_DRAWER_EMPLOYEE',
  invite: 'NAVIGATION_DRAWER_REFERRAL_CODE',
  'sign-in': 'NAVIGATION_DRAWER_LOGIN',
  'route-optimization': 'NAVIGATION_DRAWER_RO',
  gamification: 'NAVIGATION_DRAWER_GAMIFICATION',
  info: 'NAVIGATION_DRAWER_NOTIFICATION',
  statistics: 'NAVIGATION_DRAWER_STATISTIC',
  help: 'NAVIGATION_DRAWER_HELP'
}
export default {
  name: 'NavigationDrawer',
  props: ['app'],
  components: {
    HeaderSidebarV2,
    SidebarV2,
    SidebarV2Collapse,
    SearchNotFound,
    ListMenuV1,
    ListMenuItemWithoutProfile,
    ListMenuV1Collapse,
    ListMenuItemMiniWithoutProfile
  },
  data() {
    let drawer = this.$store.getters.navigationDrawer ? true : null
    let mini = !!this.$store.getters.navigationMini
    return {
      panel: [true, true, true, true],
      notFound: false,
      drawer: drawer,
      titleInfo: this.$t('page.profile'),
      mini: mini,
      data_feat_v2: [],
      data_feat_v1: [],
      searchContext: '',
      itemDefaultV2: [
        {
          group_en: 'Operations',
          group_vn: 'Vận hành',
          icon: 'bookmark',
          group_id: 'operations',
          id: 'booking',
          name_en: 'Inhouse Booking',
          name_vn: 'Danh sách đơn hàng',
          url: '',
          title: 'page.booking',
          route: '/records',
          color: '#0050B3'
        },
        {
          group_en: 'Operations',
          group_vn: 'Vận hành',
          group_id: 'operations',
          id: 'dashboard',
          name_en: 'Dashboard',
          name_vn: 'Dashboard',
          url: '',
          icon: 'dashboard',
          title: 'page.dashboards',
          route: '/dashboards',
          color: '#0050B3',
          name: 'dashboards'
        },
        {
          group_en: 'Coordination',
          group_vn: 'Điều phối',
          group_id: 'coordinate',
          id: 'employees',
          name_en: 'employees',
          name_vn: 'Danh sách nhân viên',
          url: '',
          icon: 'people',
          title: 'page.employees',
          route: '/employees',
          color: '#0050B3',
          name: 'employees'
        }
      ],
      itemDefaultV1: [
        {
          icon: 'bookmark',
          title: 'page.booking',
          route: '/records',
          color: '#0050B3',
          name: 'records'
        },
        {
          icon: 'dashboard',
          title: 'page.dashboards',
          route: '/dashboards',
          color: '#0050B3',
          name: 'dashboards'
        },
        {
          icon: 'event_available',
          title: 'page.verify_order',
          route: '/verify-order',
          color: '#0050B3',
          name: 'verify_order'
        },
        {
          icon: 'people',
          title: 'page.employees',
          route: '/employees',
          color: '#0050B3',
          name: 'employees'
        }
      ]
    }
  },
  computed: {
    groupedNavItems() {
      const normalizeUrl = (url) => url.replace(/\/$/, '')

      const groupedItems = {}
      for (const item of this.navItems) {
        if (!groupedItems[item.group_en]) {
          groupedItems[item.group_en] = []
        }
        groupedItems[item.group_en].push(item)
      }
      // const currentUrl = window.location.pathname
      // const queryUrl = window.location.search
      for (const group in groupedItems) {
        for (const item of groupedItems[group]) {
          if (
            this.$route.fullPath.includes(item.route) ||
            item.route === this.$route.path ||
            `${normalizeUrl(this.$route.path)}?p=${this.$route.query.p}`.includes(item.route)
          ) {
            item.active = true
          } else {
            item.active = false
          }
        }
      }
      return groupedItems
    },
    kaProfile: {
      cache: false,
      get() {
        return this.$store.getters.kaProfile
      }
    },
    hasKaProfileV2() {
      return Boolean(this.kaProfile && this.kaProfile.features_v2 && this.kaProfile.features_v2)
    },
    navItems: {
      cache: true,
      get() {
        const route = this.$route && this.$route.path
        const userProfile = this.$store.getters.userProfile
        let result = [
          {
            icon: 'bookmark',
            title: 'page.booking',
            route: '/records',
            color: '#0050B3',
            name: 'records'
          },
          {
            icon: 'dashboard',
            title: 'page.dashboards',
            route: '/dashboards',
            color: '#0050B3',
            name: 'dashboards'
          },
          {
            icon: 'event_available',
            title: 'page.verify_order',
            route: '/verify-order',
            color: '#0050B3',
            name: 'verify_order',
            hidden:
              !userProfile ||
              !userProfile.partner ||
              this.$constants.NEED_CONFIRM_PICKUP_PARTNERS.indexOf(userProfile.partner) === -1
          },
          {
            icon: 'people',
            title: 'page.employees',
            route: '/employees',
            color: '#0050B3',
            name: 'employees'
          }
        ]
        let resultV2 = [
          {
            group_en: 'Operations',
            group_vn: 'Vận hành',
            icon: 'bookmark',
            group_id: 'operations',
            id: 'booking',
            name_en: 'Inhouse Booking',
            name_vn: 'Danh sách đơn hàng',
            url: '',
            title: 'page.booking',
            route: '/records',
            color: '#0050B3'
          },
          {
            group_en: 'Operations',
            group_vn: 'Vận hành',
            group_id: 'operations',
            id: 'dashboard',
            name_en: 'Dashboard',
            name_vn: 'Dashboard',
            url: '',
            icon: 'dashboard',
            title: 'page.dashboards',
            route: '/dashboards',
            color: '#0050B3',
            name: 'dashboards'
          },
          {
            group_en: 'Coordination',
            group_vn: 'Điều phối',
            group_id: 'coordinate',
            id: 'employees',
            name_en: 'employees',
            name_vn: 'Danh sách nhân viên',
            url: '',
            icon: 'people',
            title: 'page.employees',
            route: '/employees',
            color: '#0050B3',
            name: 'employees'
          }
        ]
        const isCoopMart =
          get(userProfile, 'partner') === this.$constants.HARDCODED_PARTNER.COOP_MART
        const isAnCuong = get(userProfile, 'partner') === this.$constants.HARDCODED_PARTNER.ANCUONG
        const saasPermissions = get(userProfile, 'saas_permissions', [])

        if (isCoopMart) {
          if (this.kaProfile && this.kaProfile.features_v2) {
            resultV2.find((s) => s.name === 'dashboards').title = 'page.sgc_dashboards'
            const isChildAccount = get(userProfile, 'parent_id') || ''
            if (isChildAccount) {
              if (!saasPermissions.includes('DASHBOARD')) {
                resultV2 = resultV2.filter((s) => s.name !== 'dashboards')
              }

              if (!saasPermissions.includes('BOOKING')) {
                resultV2 = resultV2.filter((s) => s.name !== 'records')
              }

              if (!saasPermissions.includes('MANAGE_USER')) {
                resultV2 = resultV2.filter((s) => s.name !== 'employees')
              }
            }
          } else {
            result.find((s) => s.name === 'dashboards').title = 'page.sgc_dashboards'

            const isChildAccount = get(userProfile, 'parent_id') || ''
            if (isChildAccount) {
              if (!saasPermissions.includes('DASHBOARD')) {
                result = result.filter((s) => s.name !== 'dashboards')
              }

              if (!saasPermissions.includes('BOOKING')) {
                result = result.filter((s) => s.name !== 'records')
              }

              if (!saasPermissions.includes('MANAGE_USER')) {
                result = result.filter((s) => s.name !== 'employees')
              }
            }
          }
        }

        const whiteList = get(this.kaProfile, 'superadmin_whitelist', [])
        const userId = get(userProfile, '_id')
        const isNotChildAccount = userProfile && !userProfile.parent_id
        const isSuperAdminAccount = whiteList.includes(userId)
        let hasPermissionsV3 = false

        if (this.kaProfile) {
          if (this.kaProfile.features_v2) {
            this.kaProfile.features_v2.forEach((feature) => {
              if (feature.enable) {
                const featureID = feature.id && feature.id.toUpperCase().replace(/[^\w\s]/gi, '')
                const hasPermission =
                  saasPermissions.findIndex((p) => {
                    const permission = p.toUpperCase().replace(/[^\w\s]/gi, '')
                    return permission.indexOf(featureID) > -1
                  }) > -1
                if (isSuperAdminAccount || hasPermission) {
                  if (feature.url) {
                    resultV2.push({
                      icon: feature.icon || 'report_problem',
                      title: feature.name,
                      route: `/feature?p=${feature.id}`,
                      color: '#0050B3',
                      id: feature.id,
                      group_id: feature.group_id,
                      group_vn: feature.group_vn,
                      group_en: feature.group_en,
                      name_vn: feature.name_vn,
                      name_en: feature.name_en
                    })
                    if (isCoopMart && feature.id === 'storelocation') {
                      if (saasPermissions.includes('MANAGE_USER')) {
                        resultV2 = resultV2.filter((s) => s.name !== 'employees')
                        resultV2.push({
                          enable: true,
                          group_en: 'Coordination',
                          group_vi: 'Điều phối',
                          group_id: 'coordinate',
                          id: 'employees',
                          name_en: 'employees',
                          name_vn: 'Danh sách nhân viên',
                          url: '',
                          icon: 'people',
                          title: 'page.sgc_employees',
                          route: '/employees',
                          color: '#0050B3'
                        })
                      }
                    }
                  } else {
                    if (!resultV2.some((e) => e.route === `${feature.id}`)) {
                      resultV2.push({
                        icon: feature.icon,
                        title: feature.name,
                        route: `/${feature.id}`,
                        color: '#0050B3',
                        id: feature.id,
                        group_id: feature.group_id,
                        group_vn: feature.group_vn,
                        group_en: feature.group_en,
                        name_vn: feature.name_vn,
                        name_en: feature.name_en
                      })
                    }
                  }
                }

                if (feature.id === 'records-v2') {
                  resultV2 = resultV2.filter((e) => e.route !== '/records-v2')
                  resultV2.unshift({
                    icon: feature.icon,
                    title: feature.name,
                    route: `/${feature.id}`,
                    color: '#0050B3',
                    id: feature.id,
                    group_id: feature.group_id,
                    group_vn: feature.group_vn,
                    group_en: feature.group_en,
                    name_vn: feature.name_vn,
                    name_en: feature.name_en
                  })
                }

                if (!hasPermissionsV3) hasPermissionsV3 = feature.id.includes('employees')
              }
            })
          }

          if (this.kaProfile.features) {
            const features = this.kaProfile.features
            features.forEach((feature) => {
              if (feature.enable) {
                const featureID = feature.id && feature.id.toUpperCase().replace(/[^\w\s]/gi, '')
                const hasPermission =
                  saasPermissions.findIndex((p) => {
                    const permission = p.toUpperCase().replace(/[^\w\s]/gi, '')
                    return permission.indexOf(featureID) > -1
                  }) > -1
                const byPass = get(feature, 'bypass', false)

                if (isNotChildAccount || hasPermission || byPass) {
                  if (feature.url) {
                    result.push({
                      icon: feature.icon || 'report_problem',
                      title: feature.name,
                      route: `/feature?p=${feature.id}`,
                      color: '#0050B3',
                      name: feature.name
                    })
                    if (isCoopMart && feature.id === 'storelocation') {
                      // reorder menu, employees will below store-location
                      if (saasPermissions.includes('MANAGE_USER')) {
                        result = result.filter((s) => s.name !== 'employees')
                        result.push({
                          icon: 'people',
                          title: 'page.sgc_employees',
                          route: '/employees',
                          color: '#0050B3',
                          name: 'employees'
                        })
                      }
                    }
                  } else {
                    if (!result.some((e) => e.route === `${feature.id}`)) {
                      result.push({
                        icon: feature.icon,
                        title: feature.name,
                        route: `/${feature.id}`,
                        color: '#0050B3',
                        name: feature.name
                      })
                    }
                  }
                }

                if (feature.id === 'records-v2') {
                  result = result.filter((e) => e.route !== '/records-v2')
                  result.unshift({
                    icon: feature.icon,
                    title: feature.name + ` ${isAnCuong && isSuperAdminAccount ? ' - Mới' : ''}`,
                    route: `/${feature.id}`,
                    color: '#0050B3',
                    name: feature.name
                  })
                }
              }
            })
          }
          if (!this.kaProfile.reports || this.kaProfile.reports.length === 0) {
            if (this.kaProfile && this.kaProfile.features_v2) {
              const foundIndexV2 = resultV2.findIndex((r) => r.name === 'dashboards')
              if (foundIndexV2 >= 0) {
                resultV2.splice(foundIndexV2, 1)
              }
            } else {
              const foundIndex = result.findIndex((r) => r.name === 'dashboards')
              if (foundIndex >= 0) {
                result.splice(foundIndex, 1)
              }
            }
          }
        }
        resultV2.forEach((item) => {
          const normalizeUrl = (url) => url.replace(/\/$/, '')
          if (this.$route) {
            item.active =
              this.$route.path === item.route ||
              normalizeUrl(this.$route.fullPath).includes(normalizeUrl(item.route)) ||
              `${normalizeUrl(this.$route.path)}?p=${this.$route.query.p}`.includes(item.route)
          }

          if (route === '/v3/ro-tool') {
            const index = resultV2.findIndex((element) => element.route === '/route-optimization')
            if (index > -1) {
              resultV2[index].active = true
            }
          }
        })
        if (resultV2.some((e) => e.route === '/records-v2')) {
          resultV2 = resultV2.filter((e) => e.route !== '/records')
        }
        if (hasPermissionsV3) {
          resultV2 = resultV2.filter((e) => e.route !== '/employees')
        }
        if (this.data_feat_v2 && this.data_feat_v2.length > 0) {
          this.data_feat_v2.forEach((item) => {
            item.active = route === item.route || item.route === this.$route.fullPath
            if (route === '/v3/ro-tool') {
              const index = resultV2.findIndex((element) => element.route === '/route-optimization')
              if (index > -1) {
                this.data_feat_v2[index].active = true
              }
            }
          })
        }
        result.forEach((item) => {
          item.active = route === item.route || item.route === this.$route.fullPath
          if (route === '/v3/ro-tool') {
            const index = result.findIndex((element) => element.route === '/route-optimization')
            if (index > -1) {
              result[index].active = true
            }
          }
        })

        if (result.some((e) => e.route === '/records-v2')) {
          if (isAnCuong) {
            const hasRecordsV2Permission = saasPermissions.some(
              (p) => p === 'records-v2' || p === 'records_v2'
            )
            if (!isSuperAdminAccount && !hasRecordsV2Permission) {
              result = result.filter((e) => e.route !== '/records-v2')
            } else {
              result = result.filter((e) => e.route !== '/records')
            }
          } else {
            result = result.filter((e) => e.route !== '/records')
          }
        }

        const isBigC = get(userProfile, 'partner') === this.$constants.HARDCODED_PARTNER.BIGC
        if (isBigC) {
          const enableOutbound = get(userProfile, 'saas_config.store.enable_outbound', false)

          if (!enableOutbound && !whiteList.includes(userId)) {
            result = result.filter((e) => e.route !== '/bigc-outbound')
          }
        }

        const data_feat_v2 = this.data_feat_v2
        if (data_feat_v2 && data_feat_v2.length > 0) {
          if (data_feat_v2 && data_feat_v2.length > 0) {
            this.data_feat_v2.forEach((feature) => {
              if (feature.enable) {
                const featureID = feature.id && feature.id.toUpperCase().replace(/[^\w\s]/gi, '')
                const hasPermission =
                  saasPermissions.findIndex((p) => {
                    const permission = p.toUpperCase().replace(/[^\w\s]/gi, '')
                    return permission.indexOf(featureID) > -1
                  }) > -1

                if (isNotChildAccount || hasPermission) {
                  if (feature.url) {
                    const existingFeatureIndex = this.data_feat_v2.findIndex(
                      (item) => item.id === feature.id
                    )

                    if (existingFeatureIndex !== -1) {
                      this.data_feat_v2.splice(existingFeatureIndex, 1)
                    }

                    this.data_feat_v2.push({
                      icon: feature.icon || 'report_problem',
                      title: feature.name,
                      route: `/feature?p=${feature.id}`,
                      color: '#0050B3',
                      id: feature.id,
                      group_id: feature.group_id,
                      group_vn: feature.group_vn,
                      group_en: feature.group_en,
                      name_vn: feature.name_vn,
                      name_en: feature.name_en
                    })
                    if (isCoopMart && feature.id === 'storelocation') {
                      // reorder menu, employees will below store-location
                      if (saasPermissions.includes('MANAGE_USER')) {
                        resultV2 = resultV2.filter((s) => s.name !== 'employees')
                        resultV2.push({
                          enable: true,
                          group_en: 'Coordination',
                          group_vi: 'Điều phối',
                          group_id: 'coordinate',
                          id: 'employees',
                          name_en: 'employees',
                          name_vn: 'Danh sách nhân viên',
                          url: '',
                          icon: 'people',
                          title: 'page.sgc_employees',
                          route: '/employees',
                          color: '#0050B3'
                        })
                      }
                    }
                  } else {
                    if (!resultV2.some((e) => e.route === `${feature.id}`)) {
                      resultV2.push({
                        icon: feature.icon,
                        title: feature.name,
                        route: `/${feature.id}`,
                        color: '#0050B3',
                        id: feature.id,
                        group_id: feature.group_id,
                        group_vn: feature.group_vn,
                        group_en: feature.group_en,
                        name_vn: feature.name_vn,
                        name_en: feature.name_en
                      })
                    }
                  }
                }

                if (feature.id === 'records-v2') {
                  resultV2 = resultV2.filter((e) => e.route !== '/records-v2')
                  resultV2.unshift({
                    icon: feature.icon,
                    title: feature.name,
                    route: `/${feature.id}`,
                    color: '#0050B3',
                    id: feature.id,
                    group_id: feature.group_id,
                    group_vn: feature.group_vn,
                    group_en: feature.group_en,
                    name_vn: feature.name_vn,
                    name_en: feature.name_en
                  })
                }
              }
            })
          }
        }
        let resultGroup = groupBy(
          this.data_feat_v2.length > 0 ? this.data_feat_v2 : resultV2,
          (e) => e.group_en
        )

        let nextPaymentDate = this.$_globalMixin_opsTech_checkPaymentStatus()

        if (this.kaProfile && !this.kaProfile.features_v2) {
          if (nextPaymentDate) {
            result = result.filter((r) => r.route.includes('transaction'))
          }
          return result
        }

        if (this.hasKaProfileV2) {
          result = resultGroup
          if (nextPaymentDate) {
            for (const key in result) {
              const groupData = result[key].filter(
                (r) => r.route.includes('transaction') || r.id.includes('transaction')
              )
              if (groupData.length === 0) delete result[key]
              else result[key] = groupData
            }
          }
        }

        console.log(result)
        if (this.hasKaProfileV2 && this.mini) {
          result = flatten(Object.values(resultGroup))
          return result
        }

        return result
      }
    },
    navigationDrawer: {
      cache: false,
      get() {
        return this.$store.getters.navigationDrawer
      }
    },
    token: {
      cache: false,
      get() {
        return this.$store.getters.token
      }
    },
    darkTheme() {
      const theme =
        this.$store.getters.theme || getItemStorage('darkTheme') === 'true' ? true : false
      if (!theme) return false
      return theme
    },
    navigationMini() {
      return this.$store.getters.navigationMini
    },
    profile: {
      cache: false,
      get() {
        return this.$store.getters.userProfile
      }
    }
  },
  watch: {
    navigationMini(val) {
      if (!this.isMobile) {
        this.mini = val
      }
      if (this.isMobile) {
        this.mini = true
      }
    },

    navigationDrawer(val) {
      if (this.isMobile) {
        this.drawer = val
      }
    }
  },
  methods: {
    logout() {
      const api = process.env.VUE_APP_API_URL.concat('/v1/user/logout')
      const params = {
        token: this.token
      }
      this.axios
        .get(api, { params: params })
        .then(() => {
          this.resetUserProfile()
          this.changeNavicationMini()
          this.hasKaProfileV2 = false
        })
        .catch((error) => {
          const errorData = (error && error.response && error.response.data) || {}
          let errorMessage =
            (errorData && (errorData.description || errorData.title)) ||
            this.$t('profile.logout_error')
          if (errorMessage === 'Token not found') {
            this.resetUserProfile()
          } else {
            this.$store.dispatch('setSnackbar', {
              visible: true,
              title: errorMessage,
              color: 'error'
            })
          }
          this.$sentry.appCaptureException(
            new Error(`Logout Error: ${JSON.stringify(error.response || error)}`),
            'Logout'
          )
        })
    },
    resetUserProfile() {
      this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN)
      this.$store.dispatch('signOut')
      removeItemStorage(this.$constants.LOCAL_STORAGE_KEY__USER)
      this.$router.push({ name: 'sign-in' })
      if (this.$analyticTracking && this.$trackingEvents) {
        this.$analyticTracking.logEvent(
          this.$trackingEvents.ACTIONS.NON_INTERACTION,
          this.$trackingEvents.EVENTS.LOGOUT_SUCCESS,
          {}
        )
      }
    },
    changeNavicationMini() {
      if (this.isMobile) {
        this.$store.dispatch('setNavigationDrawer', null)
      } else {
        const value = !this.navigationMini
        this.$store.dispatch('setNavigationMini', value)
        this.panel = [true, true, true, true]
        this.searchContext = ''
        this.data_feat_v2 = []
        this.data_feat_v1 = []
      }
    },
    handleOnChange: debounce(function (searchTerm) {
      if (searchTerm !== '') {
        if (!this.hasKaProfileV2) {
          this.searchContext = searchTerm
          const combinedData = this.navItems
          const options = {
            minMatchCharLength: 2,
            keys: ['name', 'title']
          }
          const fuse = new Fuse(combinedData, options)
          let searchResultv1 = fuse.search(searchTerm)
          if (!searchResultv1 || searchResultv1.length === 0) {
            this.notFound = true
          }
          this.data_feat_v1 = searchResultv1
        }
        this.searchContext = searchTerm
        const options = {
          minMatchCharLength: 2,
          threshold: 0.2,
          keys: ['name_vn', 'name_en', 'group_en', 'group_vn', 'name']
        }
        const fuse = new Fuse(this.kaProfile.features_v2.concat(this.itemDefaultV2), options)
        let searchResult = fuse.search(searchTerm)
        if (searchResult.length === 0) {
          this.notFound = true
        } else {
          this.notFound = false
        }
        this.data_feat_v2 = searchResult
      } else {
        this.panel = [true, true, true, true]
        this.searchContext = ''
        this.notFound = false
        this.data_feat_v2 = []
        this.data_feat_v1 = []
      }
    }, 300),
    onClickToNavicationItem($event, item) {
      this.data_feat_v2 = []
      if (item.route) {
        if ($event && $event.metaKey) {
          const route = this.$router.resolve({ path: item.route })
          window.open(route.href, '_blank')
        } else {
          this.title = item.title
          this.$router.push({ path: item.route })
        }
      } else if (item.url) {
        window.open(item.url, '_blank')
      }

      if (this.isMobile) {
        this.$store.dispatch('setNavigationDrawer', null)
      } else {
        this.$store.dispatch('setNavigationMini', true)
      }

      const trackingEvent = TRACKING_EVENTS[item.name] || item.name
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS[trackingEvent] || trackingEvent,
        {
          menuItem: item
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.navigation-container {
  display: flex;
  //background-color: #f2f4f8;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .navigation-header {
    flex: 0;
    padding: 24px 16px;
  }

  .navigation-content {
    flex: 1;
    overflow: hidden;
    height: 100%;

    .menu-content-v2 {
      height: 100%;
    }

    .menu-content-v1 {
      height: 100%;
      padding: 0 16px;
    }
  }

  .navigation-footer {
    flex: 0;
    padding: 0 16px;

    .footer-container-mini {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .divider-line {
        background-color: #e6e9ec;
        height: 2px;
        border-radius: 2px;
      }

      .info-container-mini {
        padding: 12px 0;
        margin: 8px 0;
        cursor: pointer;

        .v-list__tile__avatar {
          .v-avatar {
            width: 24px !important;
            height: 24px !important;
            font-size: 10px;
          }
        }
      }

      .logout-content-mini {
        padding: 12px 0 16px 0;
        margin: 8px 0 24px 0;
        cursor: pointer;
      }
    }

    .footer-container {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .divider-line {
        background-color: #e6e9ec;
        height: 2px;
        border-radius: 2px;
      }

      .dark-divider-line {
        background-color: rgba(255, 255, 255, 0.18);
        height: 2px;
        border-radius: 2px;
      }

      .info-container {
        display: flex;
        gap: 12px;
        padding: 16px 0;
        cursor: pointer;

        .v-list__tile__avatar {
          display: flex;
          align-items: center;
          min-width: auto;

          .v-avatar {
            width: 24px !important;
            height: 24px !important;
            font-size: 10px;
          }
        }

        .info-content {
          cursor: pointer;
          display: flex;
          gap: 12px;
        }
      }

      .logout-content {
        display: flex;
        gap: 12px;
        padding: 16px 0;
        cursor: pointer;
      }

      .version-text {
        text-align: center;
        padding: 16px;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #a2a9b0;

        p {
          margin-bottom: 0 !important;
        }
      }
    }
  }
}
</style>
